export interface TemplateOption {
  id: number;
  option: string;
}
